<script>
import { nextTick, ref, watchEffect } from 'vue'
import { useUserStore } from '@/stores/UserStore'
import { storeToRefs } from 'pinia'
import { useBanners } from '@/composables/useBanners'
import { postAiAssistantAccess } from '@/api/chat/postAiAssistantAccess'
import { usePlatform } from '@/composables/usePlatform'

export default {
  components: {},
  setup () {
    const bannerData = ref(null)
    const fsBunnerShown = ref(null)
    const userStore = useUserStore()
    const { isPhone } = usePlatform()
    const { user } = storeToRefs(userStore)
    const { banners } = useBanners()

    const closeModal = async () => {
      fsBunnerShown.value = false
      await postAiAssistantAccess({ is_assist_banner: 1 })
    }

    watchEffect(() => {
      // for test: remove && !isPhone from line below
      if (!user?.value?.is_assist_banner && banners.value) {
        bannerData.value = banners.value.find(
          (banner) => banner.type === 'startai'
        )

        if (bannerData.value !== undefined) {
          fsBunnerShown.value = true
        }
      } else {
        fsBunnerShown.value = false
      }
    })

    watchEffect(async () => {
      if (fsBunnerShown.value) {
        await nextTick()
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    })

    return {
      bannerData,
      fsBunnerShown,
      closeModal,
      isPhone
    }
  }
}
</script>

<template>
  <Transition name="fade" mode="out-in">
    <div v-if="fsBunnerShown" class="assistant-banner">
      <div class="assistant-banner__content" @click="closeModal">
        <div class="assistant-banner__content-wrapper">
          <h1 class="assistant-banner__title" v-html="bannerData?.title"></h1>
          <p class="assistant-banner__preview" v-html="bannerData?.preview"></p>
        </div>
        <div class="assistant-banner__footer">
          <ul>
            <li></li>
            <li></li>
            <li></li>
            <li class="assistant-banner__assistant">
              <img
                src="@/assets/uploads/images/chat/ai-assistant.png"
                alt="assistant"
              />
              <span>Катрин</span>
            </li>
            <li></li>
          </ul>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
.assistant-banner--desktop {
  max-width: 700px;
  margin: 0 auto;
}

.assistant-banner {
  background-color: rgba($color: #000000, $alpha: 0.8);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999999999;
  &__content {
    width: 100%;
    height: 100%;
    color: #002856;
    cursor: pointer;
  }
  &__content-wrapper {
    background-color: #fff;
    width: 90%;
    padding: 20px;
    border-radius: 8px;
    position: absolute;
    left: 5%;
    bottom: 100px;
  }
  &__title {
    font-weight: 700;
    font-size: 16px;
    text-align: left;
    margin-bottom: 16px;
  }
  &__preview {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    text-align: left;
  }
  &__footer {
    height: 90px;
    width: 100%;
    position: absolute;
    bottom: 0;
    padding-bottom: 10px;
    ul {
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    li {
      display: flex;
      padding: 12px 0px;
      width: 70px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 6px;
      max-width: 75px;
    }
    span {
      color: #002856;
      font-family: Circe;
      font-size: 9.5px;
      font-weight: 700;
      line-height: 9px;
      text-align: center;
    }
    img {
      width: 30px;
      height: 30px;
    }
  }
  &__assistant {
    background-color: #fff;
    border-radius: 8px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
